import { createSelector } from '@reduxjs/toolkit';
import type { AppState } from '@src/providers/AppStateProvider/types';

/** Retrieve the full stored AppConfig for subsequent storage/display */
export const selectFullAppConfig = createSelector(
  (state: AppState) => state.appConfig.nonReduxConfig.configState,
  (state: AppState) => state.appConfig.reduxConfig,
  (nonReduxConfig, reduxConfig) => {
    return {
      ...nonReduxConfig,
      ...reduxConfig,
    };
  }
);
